import React from "react";
import { Card, Badge } from "react-bootstrap";

/**
 * EmptyCardVariation Component
 *
 * Props:
 * - eclData: The ECL variation data to display (expects { Title, Amount, DepartureDate, ArrivalDate })
 * - badgeColorDeparture: Badge color for departure date (default: "warning")
 * - badgeColorArrival: Badge color for arrival date (default: "info")
 */
const EmptyCardVariation = ({
  eclData,
  badgeColorDeparture = "warning",
  badgeColorArrival = "info",
}) => {
  if (!eclData) {
    return <Card></Card>;
  }

  const { Title, Amount, DepartureDate, ArrivalDate } = eclData;

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return (
    <Card className="h-100" style={{ boxShadow: "none" }}>
      <Card.Body className="py-3 text-center d-flex flex-column justify-content-center">
        {/* Montant */}
        <div className="fw-medium fs-8">{formatter.format(Amount)}</div>

        {/* Titre */}
        <div className="text-muted mb-2">{Title}</div>

        {/* Dates */}
        {DepartureDate && ArrivalDate && (
          <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap">
            <span>Between</span>
            <Badge bg={badgeColorDeparture}>{DepartureDate}</Badge>
            <span>and</span>
            <Badge bg={badgeColorArrival}>{ArrivalDate}</Badge>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default EmptyCardVariation;
